import React from 'react';
import ContentArea from '../components/content-area/Content';
import HostingList from '../components/hosting/HostingList';
import LiveTvOutlinedIcon from '@mui/icons-material/LiveTvOutlined';

const Hosting = () => (
  <ContentArea title="Hosting" icon={<LiveTvOutlinedIcon sx={{ fontSize: { xs: 20, sm: 24, md: 28 } }} />} container={false}>
    <HostingList />
  </ContentArea>
);

export default Hosting;
